<div class="his-wizard">
    <div class="his-wizard-menu">
        @if (sidebarVisible) {
        <p-panelMenu #menu [model]="menuItems"></p-panelMenu>
        }
    </div>

    <!-- <p-steps [model]="pages" [readonly]="true"></p-steps> -->

    <div [ngClass]="'his-wizard-content p-accordion p-component'" [ngStyle]="style" [class]="styleClass">
        <p-progressBar [value]="progressValue">
            <ng-template pTemplate="content" let-value>
                <span>{{currentStep}} / {{totalActiveSteps}}</span>
            </ng-template>
        </p-progressBar>

        <ng-content></ng-content>
        @if (hideAccordion) {
        <p-overlayPanel
                        #mobileStepMenu
                        styleClass="wizard-mobile-overlay"
                        [dismissable]="true"
                        [showCloseIcon]="false"
                        (onShow)="mobileMenuOpen = true"
                        (onHide)="mobileMenuOpen = false">

            <div class="his-wizard-menu">
                <p-panelMenu #menu [model]="menuItems"></p-panelMenu>
            </div>
        </p-overlayPanel>
        }
        <!-- <p-toast class="his-toast" position="bottom-right"></p-toast> -->
    </div>
</div>
<div class="his-wizard-summary">


</div>
<!-- <section class="his-wizard">
@for (item of items; track item; let i=$index) {
    <div class="his-wizard__item" [class.disabled]="item.disabled"
      [class.active]="expanded.has(i) || i===0">
      <ng-container [ngTemplateOutlet]="(item?.customHeader?.templateRef || defaultHeader)"
      [ngTemplateOutletContext]="{$implicit: item, index: i, toggle: getToggleState(i)}"></ng-container>
      <div class="his-wizard__content" [class.expanded]="expanded.has(i)"
        [@contentExpansion]="expanded.has(i) ? 'expanded':'collapsed'">
        <ng-container *ngTemplateOutlet="item?.content?.templateRef"></ng-container>
    
        @if (i !== 0) {
            <button hisImage="ARROW_LEFT_FAT" class="button_highlighted blue" (click)="prev(i)">
        }
        {{'wizard.previous' | hisUi}}</button>
        @if (i === 0) {
            <button class="button_highlighted blue">
        }
        {{'wizard.overview' | hisUi}}</button>
        @if (hasNextPage(i)) {
            <button hisImage="ARROW_RIGHT_FAT" class="button_highlighted" (click)="next(i)">
        }
        {{'wizard.next' | hisUi}}</button>
        @if (!hasNextPage(i)) {
            <button hisImage="TICK" class="button_highlighted">
        }
        {{'common.save' | hisUi}}</button>
      </div>
    </div>
}
</section>

<ng-template #defaultHeader let-item let-index="index">
  <header class="his-wizard__header" (click)="item.disabled ? {} :toggleState(index)"
    (keyup)="item.disabled ? {} :toggleState(index)">
    <ng-container *ngTemplateOutlet="item?.customTitle?.templateRef || defaultTitle"></ng-container>
    <button class="his-wizard__toggle-btn" [disabled]="item.disabled">
      <img hisImage="RESULTSET_DOWN" class="inlineicon">
    </button>
  </header>
  <ng-template #defaultTitle>
    <h4>
      <p class="his-wizard__title">{{item?.title}}</p>
    </h4>
  </ng-template>
</ng-template> -->
